import moment from 'moment';
import React from 'react';

interface IProps {
  rawDate: string;
}

const DateBox = ({ rawDate }: IProps): JSX.Element => {
  const date = moment(rawDate, 'YYYY-MM-DD');
  return (
    <div className="date-box">
      <span className="date-box__wday">{date.format('ddd')}</span>
      <span className="date-box__nday">{date.format('DD')}</span>
      <span className="date-box__month">{date.format('MMM')}</span>
    </div>
  );
};
export { DateBox };
